import { Map } from 'immutable';
import actionTypes from '../../actions/actionTypes'
import requestStatus from '../../constants/requestStatus'
import { returnStateIfNoAction } from '../helpers';
import { onGet, onSuccess, onError } from '../helpers-request';

const INIT_STATE = Map({
    status: requestStatus.INITIALIZED,
    error: null,
    data: Map(), // Map of any any
})

const dataReducer = (state = INIT_STATE, action) => {
    returnStateIfNoAction(action, state)

    switch(action.type){
        case actionTypes.WP_DATA_GET_REQUEST:
        case actionTypes.WP_DATA_UPDATE_REQUEST:
            return onGet(state);
        case actionTypes.WP_DATA_GET_SUCCESS:
        case actionTypes.WP_DATA_UPDATE_SUCCESS:
            return onSuccess(state, action);
        case actionTypes.WP_DATA_GET_ERROR:
        case actionTypes.WP_DATA_UPDATE_ERROR:
            return onError(state, action);
        default:
            return state;
    }
}

export default dataReducer;